module.exports = __webpack_public_path__ + "img/logo.639a00cf.svg";